import React from 'react';
import { Clock3 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

const ApprovalPendingPage: React.FC = () => {
  const { user, logout, refreshUser } = useAuth();
  if (user && user.approvalStatus !== 'PENDING') {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="tesla-login-page">
      <main className="tesla-login-main">
        <section className="tesla-login-panel">
          <div className="tesla-login-badge">
            <Clock3 size={22} color="#171A20" />
          </div>
          <h1 className="tesla-login-title">계정 승인 대기</h1>
          <p className="tesla-login-copy">
            {user?.email} 계정은 아직 승인되지 않았습니다.
            <br />
            승인 완료 후 서비스 이용이 가능합니다.
          </p>

          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              className="tesla-primary-btn"
              style={{ width: 'auto', flex: 1, whiteSpace: 'nowrap' }}
              onClick={refreshUser}
            >
              상태 다시 확인
            </button>
            <button className="btn btn-outline" style={{ whiteSpace: 'nowrap' }} onClick={logout}>
              로그아웃
            </button>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ApprovalPendingPage;
